function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M4.764 1.708c.144.07.236.215.236.375v5.834c0 .16-.092.306-.236.375-.145.07-.316.05-.44-.05l-1.97-1.575H.834c-.23 0-.417-.187-.417-.417v-2.5c0-.23.186-.417.416-.417h1.52l1.97-1.575c.125-.1.296-.12.44-.05zM4.167 2.95L2.76 4.075c-.074.06-.165.092-.26.092H1.25v1.666H2.5c.095 0 .186.032.26.092L4.167 7.05v-4.1zM9.878 3.455c.163.163.163.427 0 .59l-2.5 2.5c-.163.162-.427.162-.59 0-.162-.163-.162-.427 0-.59l2.5-2.5c.163-.162.427-.162.59 0z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.789 3.455c.162-.162.426-.162.589 0l2.5 2.5c.163.163.163.427 0 .59-.163.162-.427.162-.59 0l-2.5-2.5c-.162-.163-.162-.427 0-.59z",
  clipRule: "evenodd"
});

var SvgIcVolumeX = function SvgIcVolumeX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcVolumeX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_volume-x.cda3d4cc.svg";
export { ForwardRef as ReactComponent };